import { AppState } from '../root.reducer';

export const getInstalmentPaymentIntentSecret = (state: AppState) => state.paymentPlanInstalment.instalmentPaymentIntentSecret;
export const getInstalmentIsPolling = (state: AppState) => state.paymentPlanInstalment.isPolling;
